/**
 * Type definitions for Bar Chart Backend Service
 * These interfaces define the data structures and contracts for the migrated service
 */

export interface ChartDataConfig {
  series?: { data_type: string; field_name?: string };
  key: { data_type: string; field_name?: string };
  values: { data_type: string; field_name?: string };
}

export interface RawChartData {
  config: ChartDataConfig;
  values: Array<{
    key: string | number | null;
    series?: string;
    values: (string | number)[];
  }>;
}

export interface ChartConfig {
  chartSeries?: { 
    fieldName: string;
    dataType?: string;
  };
  chartXAxis?: {
    data_type: string;
    field_name: string;
  };
  chartValue?: {
    data_type: string;
    field_name: string;
  };
  chartColumns?: Array<{
    fieldName: string;
    type: string;
  }>;
}

export interface ProcessedDataPoint {
  key: string | number;
  values: number | null;
}

export interface ProcessedChartSeries {
  key: string;
  values: ProcessedDataPoint[];
}

export type ProcessedChartData = ProcessedChartSeries[];

// Dependency interfaces for the services this class depends on
export interface IChartBackendService {
  fetchJson(
    tableId: string, 
    filter: any, 
    config: ChartConfig, 
    isBiView?: boolean
  ): Promise<{ data: { result: { data: RawChartData } } }>;
  
  getParserForType(fieldType: string): (value: any) => any;
  
  nest(): INestBuilder;
}

export interface ISorter {
  sort<T>(
    data: T[], 
    options: { 
      dataType: string; 
      valueParser?: (item: T) => any; 
      order?: string;
    }
  ): T[];
}

export interface INestBuilder {
  key(keyFunction: (d: any) => any): INestBuilder;
  rollup(rollupFunction: (array: any[]) => any): INestBuilder;
  excludeNullKeys(exclude: boolean): INestBuilder;
  entries(data: any[]): any[];
}

export interface ServiceDependencies {
  chartBackendService: IChartBackendService;
  sorter: ISorter;
}

// Error types
export class ChartDataError extends Error {
  constructor(
    message: string,
    public details?: any
  ) {
    super(message);
    this.name = 'ChartDataError';
  }
}
